<ng-container *ishProductContextAccess="let product = product">
  <!--DIAS CUSTOMIZATION  added query params , brand is not update in refine your section of PLP if we route via brand section in pdp-->
  @if (product.manufacturer; as manufacturer) {
  <div class="product-brand">
    <a
      *ishNotFeature="'sparqueSearch'"
      [routerLink]="['/search', manufacturer]"
      [queryParams]="{ filters: 'ManufacturerName=' + manufacturer + '&page=1' }"
      [attr.aria-label]="'product.details.company.label' | translate : { '0': manufacturer }"
    >
      <span itemprop="brand">{{ manufacturer }}</span>
    </a>
    <!--DIAS CUSTOMIZATION  During sparque integration added query params , products were not  loaded-->
    <a
      *ishFeature="'sparqueSearch'"
      [routerLink]="['/search', manufacturer]"
      [queryParams]="{ filters: 'brand=' + manufacturer }"
      [attr.aria-label]="'product.details.company.label' | translate : { '0': manufacturer }"
    >
      <span itemprop="brand">{{ manufacturer }}</span>
    </a>
  </div>
  }
</ng-container>
